const slotsAvailabilityToast = (state = null, action) => {
  if (action.type === "SET_VERIFY_SLOTS_AVAILABILITY_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_VERIFY_SLOTS_AVAILABILITY_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default slotsAvailabilityToast;
